/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TransactionStatementResponse = {
    pawningContractId?: string;
    customerFirstName?: string;
    customerLastName?: string;
    totalAmount?: number;
    dueAmount?: number;
    capitalAmount?: number;
    fineAmount?: number;
    interestAmount?: number;
    paymentType?: TransactionStatementResponse.paymentType;
    accountName?: string;
    createdBy?: string;
    contractStatus?: TransactionStatementResponse.contractStatus;
};
export namespace TransactionStatementResponse {
    export enum paymentType {
        CASH = 'CASH',
        PROMPT_PAY = 'PROMPT_PAY',
        PROMPT_PAY_QR = 'PROMPT_PAY_QR',
        BANK_ACCOUNT = 'BANK_ACCOUNT',
        AUTOMATIC_QR = 'AUTOMATIC_QR',
        TRUE_WALLET = 'TRUE_WALLET',
        CHILLPAY_QR = 'CHILLPAY_QR',
    }
    export enum contractStatus {
        ONGOING = 'ONGOING',
        REDEEMED = 'REDEEMED',
        FORECLOSURE = 'FORECLOSURE',
    }
}

